import { createAsyncThunk } from '@reduxjs/toolkit';
import HistoryStore from '../../api/analytics/coveo.analytics/history-store.js';
export const addPageViewEntryInActionsHistory = createAsyncThunk('analytics/addPageViewEntry', async (itemPermanentId, { getState }) => {
    const state = getState();
    if (state.configuration.analytics.enabled) {
        HistoryStore.getInstance().addElement({
            name: 'PageView',
            value: itemPermanentId,
            time: JSON.stringify(new Date()),
        });
    }
});
